import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PremiumProvider } from "@/context/PremiumContext";
import { ScopeProvider } from "@/context/ScopeContext";
import { ThemeProvider } from "@/context/ThemeContext";
import "@/styles/command-center.css";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MorningBriefing from "@/pages/MorningBriefing";
import CrewDashboard from "@/pages/CrewDashboard";
import InviteAccept from "@/pages/InviteAccept";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PayInvoice from "@/pages/PayInvoice";
import BetaAccept from "@/pages/BetaAccept";
import PaymentCancel from "@/pages/PaymentCancel";
import SmsConsent from "@/pages/SmsConsent";
import SnapBudget from "@/pages/SnapBudget";
import TaxClarityHub from "@/pages/TaxClarityHub";
import Pricing from "@/pages/Pricing";
import AdminPortal from "@/pages/AdminPortal";
import Support from "@/pages/Support";
import AboutLegal from "@/pages/AboutLegal";
import Refer from "@/pages/Refer";
import { Footer } from "@/components/Footer";
import { BackgroundManager } from "@/components/BackgroundManager";
import MobileTabBar from "@/components/MobileTabBar";

function Protected({ children }) {
  const { user, checking } = useAuth();
  return checking || user === null ? (
    <div className="min-h-screen" data-testid="auth-loading" />
  ) : !user ? (
    <Navigate to="/login" replace />
  ) : (
    children
  );
}

function PublicOnly({ children }) {
  const { user, checking } = useAuth();
  return checking ? <div className="min-h-screen" data-testid="auth-checking" /> : user ? <Navigate to="/" replace /> : children;
}

function Home() {
  const { user } = useAuth();
  return user?.role === "crew" ? <CrewDashboard /> : <MorningBriefing />;
}

function OwnerOnly({ children }) {
  const { user } = useAuth();
  return user?.role === "crew" ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PremiumProvider>
          <ScopeProvider>
          <ThemeProvider>
          <Toaster position="top-right" richColors closeButton />
          <BackgroundManager />
          <div className="flex flex-col min-h-screen">
            <div className="flex-1">
              <Routes>
                <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
                <Route path="/join/:token" element={<InviteAccept />} />
                <Route path="/sms-consent" element={<SmsConsent />} />
                <Route path="/pay/:invoiceId" element={<PayInvoice />} />
                <Route path="/beta/:token" element={<BetaAccept />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/support" element={<Support />} />
                <Route path="/contact" element={<Support />} />
                <Route path="/about" element={<AboutLegal />} />
                <Route path="/privacy" element={<AboutLegal />} />
                <Route path="/terms" element={<AboutLegal />} />
                <Route path="/" element={<Protected><Home /></Protected>} />
                <Route path="/dashboard" element={<Protected><OwnerOnly><Dashboard /></OwnerOnly></Protected>} />
                <Route path="/snapbudget" element={<Protected><OwnerOnly><SnapBudget /></OwnerOnly></Protected>} />
                <Route path="/tax-hub" element={<Protected><OwnerOnly><TaxClarityHub /></OwnerOnly></Protected>} />
                <Route path="/refer" element={<Protected><OwnerOnly><Refer /></OwnerOnly></Protected>} />
                <Route path="/admin" element={<Protected><OwnerOnly><AdminPortal /></OwnerOnly></Protected>} />
                <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
                <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <Footer />
          </div>
          <MobileTabBar />
          </ThemeProvider>
          </ScopeProvider>
        </PremiumProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
